<template>
  <div class="animated fadeIn list-of-arpaym">
    <b-card>
      <div slot="header">List of AR Payment - Collection Settlement 
        <div class="card-header-actions">
          <b-button variant="primary mr-1" @click="add">Add</b-button>
          <b-button variant="primary mr-1" @click="edit">Edit</b-button>
          <b-button variant="primary mr-1" @click="deleteConfirm">Delete</b-button>
          <b-button variant="primary mr-1" @click="printjv()"><i class="fa fa-print"></i> Print Form</b-button>
          <b-button variant="primary mr-1" @click="exportxls()"><i class="fa fa-file-excel-o"></i>Export</b-button>
          <b-button variant="primary mr-1" @click="togleFilter()"><i class="fa fa-filter"></i> Filter</b-button>
          <b-button variant="primary mr-1" @click="close()" > <i class="fa fa-close"></i> Close</b-button>
        </div>
      </div>
      <b-row v-if="showFilter">
        <b-col lg="6">
            <b-row>
              <b-col lg="8">
                  <b-input-group >
                    <b-input-group-prepend><label>Payment Date</label></b-input-group-prepend>
                    <b-form-input v-model="tblData.tgl1" type="date" ></b-form-input>
                    <b-input-group-prepend><span class="input-group-text">until</span></b-input-group-prepend>
                    <b-form-input v-model="tblData.tgl2" type="date" ></b-form-input>
                  </b-input-group>
                </b-col>
                <b-col lg="4">
                    <b-input-group >
                      <b-input-group-prepend><span class="pt-2">Status Finance&nbsp;</span></b-input-group-prepend>
                      <b-form-select v-model="tblData.status" :plain="true" :options="dataList.arPayment"></b-form-select>
                    </b-input-group>
                </b-col>
            </b-row>            
            <b-row>
              <b-col lg="6">
                  <b-input-group >
                    <b-input-group-prepend><label>Payment Number</label></b-input-group-prepend>
                    <b-form-input v-model="tblData.nomor" placeholder="AR Payment Number"></b-form-input>
                  </b-input-group>
                </b-col>
              <b-col  lg="6">
                  <b-input-group >
                    <b-input-group-prepend><span class="pt-2">Customer &nbsp;</span></b-input-group-prepend>
                    <b-form-input v-model="tblData.customer" placeholder="Customer"></b-form-input>
                    </b-input-group>
              </b-col>
            </b-row>                      
            <b-input-group >
                <b-input-group-prepend><label>Dimension Name</label></b-input-group-prepend>
                <b-form-select v-model="tblData.DimCol" :plain="true" :options="dimension"></b-form-select>
                <b-input-group-prepend><span class="input-group-text">value</span></b-input-group-prepend>
                <b-form-input v-model="tblData.DimVal" placeholder="Dimension Value"></b-form-input>
            </b-input-group>
        </b-col>
        <b-col lg="6">
              <b-input-group >
                  <b-input-group-prepend><label>Due/Effective Date</label></b-input-group-prepend>
                  <b-form-input v-model="tblData.tgldue1" type="date" ></b-form-input>
                  <b-input-group-prepend><span class="input-group-text">until</span></b-input-group-prepend>
                  <b-form-input v-model="tblData.tgldue2" type="date" ></b-form-input>
                  <b-input-group-prepend><span class="pt-2">Bank &nbsp;</span></b-input-group-prepend>
                  <b-form-input v-model="tblData.namabank" disabled ></b-form-input>
                  <b-input-group-append>
                      <b-btn text="Button" @click="lkuBankaccountShow=true">
                          <i class="fa fa-search"></i>
                      </b-btn>
                  </b-input-group-append>
              </b-input-group>
              <b-input-group >
                <b-input-group-prepend><label>Description</label></b-input-group-prepend>
                <b-form-input v-model="tblData.uraian" ></b-form-input>
                <b-form-input v-model="tblData.reference" placeholder="Reference/cheque/giro" class="ml-1"></b-form-input>
            </b-input-group>
            <b-input-group >
              <b-input-group-prepend><label>Collector</label></b-input-group-prepend>
              <b-form-select v-model="tblData.collector_id" :plain="true" :options="collectors" ></b-form-select>
              <b-input-group-append>
                    <b-button variant="success" size="sm" @click="search()" class="ml-3"> <i class="fa fa-refresh"></i> Apply Filter</b-button>                
              </b-input-group-append>
              <b-input-group-append>
                    <b-button variant="secondary" size="sm" class="ml-2" @click="clearFilter()" >Clear Filter</b-button>
              </b-input-group-append>
            </b-input-group>
        </b-col>
      </b-row>
      <b-table
        class="mb-0"
        ref="table"
        outlined
        responsive striped hover small
        style="font-size:smaller;" 
        :items="data"
        :fields="tblFields"
        :current-page="tblData.page"
        :per-page="tblData.limit"
        :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc"
        :key="tblData.limit" @row-clicked="rowClicked" 
      >
      <template v-slot:cell(action)="data">
         <b-dropdown  dropright variant="outline-secondary" toggle-class="text-decoration-none" no-caret  size="sm"  style="margin:-10px;">
          <template v-slot:button-content>
             <i class="fa fa-play text-primary"></i>
          </template>
          <b-dropdown-item @click="rowEdit(data.item)" href="#"  style="padding:0 !important;">Edit</b-dropdown-item>
          <b-dropdown-item @click="rowPrint(data.item)" href="#" style="padding:0 !important;">Print Form</b-dropdown-item>
          <b-dropdown-item @click="rowDel(data.item)" href="#"  style="padding:0 !important;"> Delete</b-dropdown-item>
        </b-dropdown>
      </template>        
      
        <template v-slot:cell(paymno)="data">
          <div v-if="((data.item.statustre==2) || (data.item.statustre==1)) " class="bg-success">{{data.item.paymno}}</div>
          <div v-else>{{data.item.paymno}}</div>
        </template>
        <template v-slot:cell(nomorbank)="data">
          <div v-if="data.item.poststatus==0" style="background-color:yellow;">{{data.item.nomorbank}}</div>
          <div v-else>{{data.item.nomorbank}}</div>
        </template>

        <template v-slot:cell(tglpaym)="data">
          {{ data.item.tglpaym | moment("DD MMM YYYY") }}
        </template>
        <template v-slot:cell(tgl_terima)="data">
          {{ data.item.tgl_terima | moment("DD MMM YYYY") }}
        </template>
        <template v-slot:cell(totalbyr)="data">
          {{data.item.matauang}}
          {{data.item.totalbyr|numFormat}}
        </template>
        <template v-slot:cell(settl_amt)="data">
          {{data.item.settl_amt|numFormat}}
        </template>
      </b-table>
      <!-- <b-row >
        <b-col cols="4">
          <div>
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total}} entries
          </div>
        </b-col>
        <b-col cols="4" >
            <b-form-group label-cols=3 label="Limit per page"  style="margin-top:0 !important;">
            <b-form-select :options="[10, 20, 30, 50, 70, 90, 120]" :plain="true" v-model="tblData.limit"  size="sm" style="width:80px;"/>
            </b-form-group>
        </b-col>        
        <b-col cols="4">            
          <b-pagination
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row> -->
      <b-row >
        <b-col cols="4">
          <div class="pt-1">
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total}} entries
          </div>
        </b-col>
        <b-col cols="5">          
          <b-input-group>
              <b-input-group-prepend><span class="pt-1 pr-2">Limit per page</span></b-input-group-prepend> 
              <b-form-input v-model="limit" type="number" class="mr-2" v-b-tooltip.hover :title="`${limit} records`" style="max-width:80px; !important;"></b-form-input>  
              <b-pagination
                v-if="pagination" 
                :total-rows="tblData.total"
                :per-page="tblData.limit"
                v-model="tblData.page"
              ></b-pagination>
          </b-input-group>
        </b-col>
        <b-col cols="3" >
          <div class="text-right pt-1">
            <span class="bg-success">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span class="mr-4">Finance Received</span>
            <span style="background-color:yellow;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span class="mr-2">Finance Not Posted</span>
          </div>
        </b-col>        
      </b-row>
    </b-card>
      <b-modal v-model="showDelConfirm" title="Delete Record?" :centered="true" @ok="deleteData">
        <p class="mb-1">1 record is about to be permanently deleted</p>
        <p class="font-weight-bold m-0 text-danger">Warning: You can't undo this action.</p>
      </b-modal>
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       
    <b-modal v-model="showReport" size="xl" scrollable title="Preview as PDF" ok-only>
        <iframe :src="reportUrl" frameborder="0"></iframe>
    </b-modal>
        <b-modal v-model="lkuBankaccountShow" size="lg" :hide-footer="true" title="List of Bank/Cash Account" :centered="true">
            <lku-bankaccount @click="onSelectLkuBankaccount" :formdata="lkuBankaccountData"></lku-bankaccount>
        </b-modal>        

  </div>
</template>

<style lang="scss">
  .list-of-arpaym {
    table {
      td:nth-child(1) {
        width: auto;
      }
      td:nth-child(2) {
        width: auto;
      }
      td {
        .dropdown-item {
            padding: 0.1rem 1.5rem !important;
            font-size: smaller !important;
        }    
      }
    }
 }
</style>


<script>
import lkuBankaccount from "../lookup/lkuBankaccountLazzy";
import crud from "../../apis/crud";
import arpayment from '../../apis/arpayment';
import dropdown from "../../data/dropdown";

import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import moment from "moment";
import toastr from "mini-toastr";
toastr.init();


export default {
  data() {
    return {
      showFilter: false,
      showDelConfirm: false,
        lkuBankaccountData:{},
      lkuBankaccountShow: false,
      isLoading:false,
      showReport:false,
      reportUrl: null,
      model:{},
      items: [],
      limit: 15,
      pagination:false,
      tblData: {
        page: 1,
        limit: 15,
        total: 0,
        tgl1:this.$store.state.user.tglaktif,
        tgl2:this.$store.state.user.akhirbln,        
        sortBy: 'tglpaym',
        sortDesc: true,
        DimCol:'Dim1', collector_id:''
      },
      dataList: {
        arPayment: dropdown.arPayment
      },      
      collectors:[{value:'',text:'--- ALL ---'}]
    };
  },
  components: {Loading,lkuBankaccount},
  computed: {
    dimension(){
      return this.$store.state.dimension;
    },
    tblFields(){
      const fields=[
        {
          key: "action",
          label: "",
          thStyle: "width:40px",
          thClass: "text-center",
        },
          {
            key: "paymno",
            thStyle: "width:100px",
            label: "Trx. Number",
            sortable: true
          },
          {
            key: "tglpaym",
            thStyle: "width:70px",
            label: "Trx. Date",
            sortable: true
          },
          {
            key: "custinfo",
            label: "Customer",
            sortable: true
          },
          {
            key: "uraian",
            label: "Description",
          },
          {
            key: "paymethod",
            label: "Payment Method",
            sortable: true
          },
          {
            key: "reference",
            label: "reff",
            thStyle: "width:60px",
          },
          {
            key: "tgl_terima",
            label: "Due/Efective Date",
            thStyle: "width:80px",
            sortable: true
          },
          {
            key: "namabank",
            label: "Destination Bank/Acc.",
            thStyle: "width:150px",
            sortable: true
          },
          {
            key: "nomorbank",
            label: "Trx.Cash/Bank#",
            thStyle: "width:110px",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true
          },
          {
            key: "totalbyr",
            label: "Payment Amount",
            thStyle: "width:120px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true
          },
          {
            key: "settl_amt",
            label: "AR Settlement Amt.",
            thStyle: "width:120px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true
          }
        ];
        const dims = this.$store.state.dimension;
        for (let i = 0; i < dims.length; i += 1) {
          fields.push(          {
            key: `${dims[i].value}Txt`,
            // thStyle: "width:100px",
            label: dims[i].text,
            sortable: true
          },)
        }
      return fields;
    },
    dimCol() {
        return this.tblData.DimCol;
    }    
  },
  watch:{
    dimCol: function(newval) {
        this.tblData.DimVal="";
        this.tblData.DimValInfo="";
        this.tblData.DimColInfo=this.dimension.find(d => d.value === newval).text;
    },
    limit: function (newVal){
      setTimeout(() => {
        if (this.limit==newVal) {
          this.tblData.limit=newVal;
        }
      }, 500);
    }    
  },
  created: async function(){
        // const tgl2 = moment(this.$store.state.user.tglaktif, 'YYYY-MM-DD').add(1,'M').subtract(1, 'day');
        // this.tblData.tgl1= this.tblData.tgl1 || this.$store.state.user.tglaktif;
        // this.tblData.tgl2= this.tblData.tgl2 || tgl2.format('YYYY-MM-DD');
        const e = await crud.list({tablename: "vwcollector",page: 1,limit: 1000,sortBy: "collector_name",sortDesc: false});
        // this.collectors=this.collectors.concat(e);
        this.collectors = e.reduce((newArr,item) =>{
            newArr.push({ value: item.collector_id, text: item.collector_name});
            return newArr;
        },[{value:'', text:'--- ALL ---'}]);
  },  
  methods: {
    onSelectLkuBankaccount(lkuData) {
        this.lkuBankaccountData=lkuData;
        this.lkuBankaccountShow=false;
        this.tblData.kodebank=lkuData.selected.kode;
        this.tblData.namabank=(lkuData.selected.namabank2 || lkuData.selected.namabank) + ' | '+lkuData.selected.nomorrek;
        this.lkuBankaccountShow=false;
    },    
    data: async function(ctx) {
      //   const filter = this.$store.state.filter;
      //   let filtered=false;
      //   for (var key in filter.arpaylist) {
      //       this.tblData[key] = filter.arpaylist[key];
      //       filtered=true;
      //   }
      //   if (filtered === true) {
      //     this.tblData.tgl1=filter.arpaylist.tgl1 || '';
      //     this.tblData.tgl2=filter.arpaylist.tgl2 || '';
      //     this.showFilter=filtered;
      //     delete filter.arpaylist;
      //     this.$store.commit("filter", filter);
      //     // this.$store.commit("filter", {});
      //   }
      // this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";

      // const list = await arpayment.list(this.tblData);    
      // this.items=list;  
      // return list;
        const tblOrder={sortBy:this.tblData.sortBy,sortDesc:this.tblData.sortDesc};
        this.pagination=false;
        const filter = this.$store.state.filter;
        let filtered=false;
        for (var key in filter.arpaylist) {
            this.tblData[key] = filter.arpaylist[key];
            filtered=true;
        }
        if (filtered === true) {
          if (!(filter.arpaylist.tgl1)) {
            this.tblData.tgl1='';
            this.tblData.tgl2='';
          }
          this.showFilter=filtered;
          delete filter.arpaylist;
          this.$store.commit("filter", filter);
          let autoRefresh=true;
            if (this.tblData.page == 1) {
              if ((tblOrder.sortBy ==this.tblData.sortBy) && (tblOrder.sortDesc==this.tblData.sortDesc)) {
                   autoRefresh=false; 
               } else autoRefresh=true; 
            }
            if (autoRefresh==false) {
                this.isLoading=true;
                this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
                try {
                  const list = await arpayment.list(this.tblData);      
                  this.pagination=true;
                  this.items = list;
                  this.isLoading=false;  
                  return list;        
                } catch (error) {
                  this.isLoading=false;  
                  if (error.message) {
                      toastr.error(error.message,'ERROR MESSAGE',10000);
                  } else {
                      toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                  }        
                }
            }
        } else {
                this.isLoading=true;
                this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
                try {
                  const list = await arpayment.list(this.tblData);      
                  this.pagination=true;
                  this.items = list;
                  this.isLoading=false;  
                  return list;        
                } catch (error) {
                  this.isLoading=false;  
                  if (error.message) {
                      toastr.error(error.message,'ERROR MESSAGE',10000);
                  } else {
                      toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                  }        
                }
        }

    },
    togleFilter() {
      this.showFilter=!this.showFilter;
    },
    refresh(ctx) {
      this.$refs.table.refresh();
    },
    search(ctx) {
      this.tblData.page=1;
      this.refresh();
    },
    clearFilter(ctx) {
        this.tblData.kodebank= '';
        this.tblData.namabank= '';
        this.tblData.reference=  '';
        this.tblData.uraian=  '';
        this.tblData.nomor=  '';
        this.tblData.customer=  '';
        this.tblData.tgl1=  '';
        this.tblData.tgl2=  '';
        this.tblData.DimVal=  '';
        this.tblData.tgldue1=  '';
        this.tblData.tgldue2=  '';
        this.tblData.status='';
        this.$forceUpdate();
    },
    saveFilter() {
      const keys = ['uraian', 'DimCol', 'DimVal', 'tgl1', 'tgl2', 'status', 'nomor', 'customer', 'kodebank','namabank', 'reference', 'tgldue1', 'tgldue2','unearned','collector_id'];
      let filtered = false;
      const arpaylist={};
      for (const key in this.tblData) {
          if (keys.indexOf(key) >= 0 && this.tblData[key]) {
              filtered=true;
              arpaylist[key]=this.tblData[key];
          }
      }
      if (filtered === true) {
          arpaylist.page=this.tblData.page;
          arpaylist.limit=this.tblData.limit;
          arpaylist.sortBy=this.tblData.sortBy;
          arpaylist.sortDesc=this.tblData.sortDesc;
          const filter = this.$store.state.filter;
          filter.arpaylist=arpaylist;
          this.$store.commit("filter", filter);
      }
    },       
    rowEdit(record) {
      this.model = record;
      this.edit();
    },
    rowPrint(record) {
      this.rowClicked(record);
        this.printjv();        
    },
    rowDel(record) {
      this.rowClicked(record);
      this.deleteConfirm();

    },

    add(){
      this.saveFilter();
      router.push({name :"receivable.arpaymfrm"});
    },
    edit: function() {
        if (this.model.arpaymKey) {
        this.saveFilter();
          router.push({name :'receivable.arpaymfrm', params: { arpaymKey: this.model.arpaymKey}});
        } else {
            toastr.warn('Please select a row that want to be Edit!');
        }
    },
    deleteConfirm() {
        if (this.model.arpaymKey) {
          this.showDelConfirm = true;
        } else {
            toastr.warn('Please select a row that want to be Delete!');
        }
    },
    deleteData: async function() {
      try {
        this.isLoading=true;
        await arpayment.remove(this.model);
      this.refresh();
        // const index= this.items.findIndex(r => (r.arpaymKey==this.model.arpaymKey));
        // this.items.splice(index, 1);
        this.isLoading=false;
      } catch (error) {
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }        
      }
    },
    rowClicked(record, index) {
      // if (this.model.arpaymKey == record.arpaymKey) {
      //     this.edit();
      // } else {
        if ((this.model) && (this.model._rowVariant)) {
            delete this.model._rowVariant;
        }
        this.model = record;
        record._rowVariant= 'info';
        this.$forceUpdate();
      // }
    },
    printjv: async function()
    {
      if (this.model.arpaymKey) {
          try {
                this.showReport=true;
              this.reportUrl= await arpayment.printjv(this.model);
              if (this.$isMobile()){
                  this.showReport=false;              
                  window.location.href= `https://docs.google.com/viewerng/viewer?url=${this.reportUrl}`;
              }
          } catch (error) {
              if (error.message) {
                  toastr.error(error.message);
              } else {
                  toastr.error(JSON.stringify(error));
              }
          }
        } else {
            toastr.warn('Please select a row that want to be Printed!');
        }
    },
    exportxls: async function() {
        this.isLoading=true;
        try {
            const response = await arpayment.exportXls(this.tblData);
            this.isLoading=false;    
        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message);
            } else {
                toastr.error(JSON.stringify(error));
            }
        }
    },    
    close(){
      router.push("/receivable/home");
    }
  }
};
</script>
